export const AI = () => (
  <svg
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M18 8L19.25 5.25L22 4L19.25 2.75L18 0L16.75 2.75L14 4L16.75 5.25L18 8Z'
      fill='#4D3D99'
    />
    <path
      d='M18 14L16.75 16.75L14 18L16.75 19.25L18 22L19.25 19.25L22 18L19.25 16.75L18 14Z'
      fill='#4D3D99'
    />
    <path
      d='M10.5 8.5L8 3L5.5 8.5L0 11L5.5 13.5L8 19L10.5 13.5L16 11L10.5 8.5ZM8.99 11.99L8 14.17L7.01 11.99L4.83 11L7.01 10.01L8 7.83L8.99 10.01L11.17 11L8.99 11.99Z'
      fill='#4D3D99'
    />
  </svg>
)

export const Separator = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.4 18L5 16.6L9.575 12L5 7.4L6.4 6L12.4 12L6.4 18ZM13 18L11.6 16.6L16.175 12L11.6 7.4L13 6L19 12L13 18Z'
      fill='#B2B2B2'
    />
  </svg>
)

export const DonAItions = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M19.5013 7.5L20.4413 5.44L22.5013 4.5L20.4413 3.56L19.5013 1.5L18.5613 3.56L16.5013 4.5L18.5613 5.44L19.5013 7.5Z' />
    <path d='M8.00128 7.5L8.94128 5.44L11.0013 4.5L8.94128 3.56L8.00128 1.5L7.06128 3.56L5.00128 4.5L7.06128 5.44L8.00128 7.5Z' />
    <path d='M19.5013 13L18.5613 15.06L16.5013 16L18.5613 16.94L19.5013 19L20.4413 16.94L22.5013 16L20.4413 15.06L19.5013 13Z' />
    <path d='M17.2113 9.62L14.3813 6.79C14.1813 6.6 13.9313 6.5 13.6713 6.5C13.4113 6.5 13.1613 6.6 12.9613 6.79L1.79128 17.96C1.40128 18.35 1.40128 18.98 1.79128 19.37L4.62128 22.2C4.82128 22.4 5.07128 22.5 5.33128 22.5C5.59128 22.5 5.84128 22.4 6.04128 22.21L17.2113 11.04C17.6013 10.65 17.6013 10.01 17.2113 9.62ZM13.6713 8.92L15.0813 10.33L13.9113 11.5L12.5013 10.09L13.6713 8.92ZM5.33128 20.09L3.92128 18.68L11.0913 11.5L12.5013 12.91L5.33128 20.09Z' />
  </svg>
)
